<template>
  <Layout v-if="type === 'admin'">
      <div>
      <div class="bg-white">
      <div class=" mx-auto sm:px-6  lg:px-1 lg:flex lg:items-center lg:justify-between">
         <!-- <div class="flex-shrink-0 h-28 w-28 hidden md:block pt-0 mt-3">
         <img @click="toggleMobilemenu30()"
            class="h-28 w-28 rounded"
            :src="admin.profilePic"
            alt=""
            />
          </div>-->
          <button v-if="admin.profilePic"
          type="button"
          v-on:click="removePic();"
          class="inline-flex hidden md:block items-center px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-8 w-8" src="../assets/removePic.png" alt />
        </button>
          <div v-if="mobileOpen10" class="fixed inset-0 z-50 px-4 py-6 sm:flex sm:items-center sm:justify-center">
  <!-- Backdrop overlay -->
 
  <!-- Modal Container: Changed from sm:max-w-lg to sm:max-w-4xl for a much bigger box -->
  <div class="relative bg-white rounded-lg shadow-xl transform transition-all sm:max-w-4xl sm:w-full overflow-hidden" role="dialog" aria-modal="true">
    
    <!-- Header Section -->
    <div style="background-color: #C38437" class="bg-blue-200 px-6 py-4 flex items-center">
      <img class="h-10 w-auto" src="../assets/becomeMember.png" alt="Logo" />
      <div class="ml-4">
        <h3 class="text-lg font-semibold text-white uppercase tracking-wide">
          Become a Member
        </h3>
      </div>
    </div>
         <div 
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Membership :
            </dt>
            <dd
              class="mt-0 -ml-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.membershipDate" />
            </dd>
          </div>


    <!-- Footer Section -->
    <div class="bg-gray-50 px-6 py-4 flex justify-end border-t border-gray-200">
        <button v-if="admin.membershipDate"
        type="button" 
        @click="becomeMember()" 
        class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-yellow-500 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none transition ease-in-out duration-150"
      >
        Save now 
      </button>
      <button 
        type="button" 
        @click="toggleMobilemenu10" 
        class=" ml-2 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-red-500 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none transition ease-in-out duration-150"
      >
        Close
      </button>
    </div>
  </div>
</div>
           <!-- <button 
          type="button"
          v-on:click="createArray(); updateSermon();"
          class="relative inline-flex items-center px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-6 w-6" src="../assets/save.png" alt />
          <a  class="absolute inset-0 z-6 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
         <h1 class=tracking-wider >Update Sermon</h1>
          </a>
        </button>-->
         
          <h2  class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
            {{admin.firstName}} {{admin.lastName}} - <a v-if="admin.marriageStatus === 'Married'" class="text-green-400">{{admin.marriageStatus}}</a> <a v-if="admin.marriageStatus === 'Single'" class="text-blue-400">{{admin.marriageStatus}}</a><a v-if="admin.marriageStatus === 'Divorced'" class="text-red-400">{{admin.marriageStatus}}</a><a v-if="admin.marriageStatus === 'Widowed'" class="text-orange-400">{{admin.marriageStatus}}</a><a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left"></a>
            <br />
          </h2>
         
         <h2 class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
           Member No: <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{(admin.memberNo)}}</a>
            <br />
          </h2>
             <h2 class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
           Member: <a v-if="admin.activeMember === 'NO'"  class="text-2xl font-extrabold text-red-500 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{(admin.activeMember)}}</a>
           <a v-if="admin.activeMember === 'YES'"  class="text-2xl font-extrabold text-green-500 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{(admin.activeMember)}}</a>
            <br />
          </h2>
                <button v-if="admin.activeMember === 'NO'"
          type="button"
          v-on:click="toggleMobilemenu10();"
          class="inline-flex items-center hidden md:block px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-16 w-16" src="../assets/becomeMember.png" alt />
        </button>
       
          <button v-if="currentUserData.mainAdmin === 'yes'"
          type="button"
          v-on:click="removeUser();"
          class="inline-flex items-center hidden md:block px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-6 w-6" src="../assets/bin.png" alt />
        </button>
       
           
        </div>
      </div>
    </div>
    <br v-if="mobileOpen30">
        <div v-if="mobileOpen30" class=" bg-gray-50 px-4 py-5 pl-4 pt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt  class="text-sm leading-5 font-medium text-gray-500">
            Profile Photo<p class="text-red-600"> </p>
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
            <BaseFileUploader 
              label=""
              type="file"
              :uuid="true"
              path="documents"
              @uploaded="handleAdminDocument"
            />

        </dd>
      </div>
    {{errorMessage}}
        <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b></b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div
      class="bg-white shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="admin"
    >
        <div style="background-color: #C38437" class="px-4 py-2 border-b bg-yellow-600 border-gray-200 sm:px-6">
        <h3 class="text-xl leading-6 font-medium text-gray-900">
          <p style="color: #005482" class="mt-1 max-w-2xl text-xl leading-5 text-gray-500">
          </p>
        </h3>
      </div>
      <div>
        <dl>
               <div
            class="bg-gray-50 px-4 pt-1 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Active :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="admin.activeMember"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
          
            </select>
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           First Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="admin.firstName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="First Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Last Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="admin.lastName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Last Name..."></textarea>
            </dd>
          </div>
                <div
            class="bg-gray-50 px-4 pt-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Spouse Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="admin.spouse" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Spouse Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-0 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Total Children :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="admin.children"
            >
              <option disabled value>...</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
               <option value="4">4</option>
               <option value="5">5</option>
               <option value="6">6</option>
               <option value="7">7</option>
               <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </select>
            </dd>
          </div>
            <div v-if="admin.children >= '1'"
            class="bg-gray-50 px-4 pt-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Children Names :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="500" v-model="admin.childrenNames" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Children Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Member Address :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="1000" v-model="admin.address" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Member Address..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Birth :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.birthDate" />
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Marriage Status :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="admin.marriageStatus"
            >
              <option disabled value>...</option>
              <option value="Married">Married</option>
              <option value="Single">Single</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
               <option value="Seperated">Seperated</option>
            </select>
            </dd>
          </div>
             <div v-if="admin.marriageStatus === 'Married'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Marriage :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.marriageDate" />
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Email Address :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="200" v-model="admin.emailAddress" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Email Address..."></textarea>
            </dd>
          </div>
          
              <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Mobile Number :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="12" type="number" v-model="admin.mobileNo" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Mobile Number..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Other Tel :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="12" v-model="admin.otherTel" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Other Tel..."></textarea>
            </dd>
          </div>
                <div v-if="admin.activeMember === 'YES'"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Baptized At Grace :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="admin.baptizedGrace"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
            </dd>
          </div>
                  <div v-if="admin.baptizedGrace === 'NO'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Baptism Elsewhere :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.baptismDateElse" />
            </dd>
          </div>
             <div v-if="admin.baptizedGrace === 'YES'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Baptism at Grace :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.baptismDate" />
            </dd>
          </div>
             <div v-if="admin.activeMember === 'YES'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Membership :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.membershipDate" />
            </dd>
          </div>
               <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Additional Information :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="2000" v-model="admin.additionalInformation" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Additional Information..."></textarea>
            </dd>
          </div>
             <div v-if="admin.addedBy"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           added By :
            </dt>
              <dd
              class="mt-1 text-sm leading-5 text-yellow-600 sm:mt-0 sm:col-span-2"
            >
              <label>{{admin.addedBy}}</label>
            </dd>
          </div>
              <div v-if="admin.updatedBy"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Updated By :
            </dt>
              <dd
              class="mt-1 text-sm leading-5 text-yellow-600 sm:mt-0 sm:col-span-2"
            >
              <label>{{admin.updatedBy}}</label>
            </dd>
          </div>
              <div v-if="admin.updatedBy"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Updated Date :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-yellow-600 sm:mt-0 sm:col-span-2"
            >
              <label>{{new Date(admin.updatedDate).toDateString()}}</label>
            </dd>
          </div>
      
         <div class="pl-4 ml-2 pt-2 bg-gray-50"></div>
            <BaseButton v-if="admin.activeMember === 'YES'" v-on:click="checkForm();  getFullName(); createArray(); updateMember();"  >Update Member</BaseButton>
            <BaseButton v-if="admin.activeMember === 'NO'" v-on:click="checkForm1();  getFullName(); createArray(); updateMemberNon();"  >Update Non Member</BaseButton>
         <!-- <div v-if="admin.document"
            class="bg-gray-50 px-4 py-0 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Email Manual
            </dt>
            <dd
              class="py-3 px-4 mt-1 text-lg leading-5 text-orange-600 sm:mt-0 sm:col-span-2"
            >
            <input type="email" class="w-80 h-8" id="email" name="user_email" v-model="email" placeholder="Your email.." required>
            <input type="submit" value="Send Now" class=" inline-flex text-xl items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-blue-600 transition duration-150 ease-in-out">
            </dd>
          </div> -->
          <div>

       </div>
          <div class="pl-10"></div>
        </dl>
      </div>
    </div>

       
  </Layout>
</template>

<script>
import Layout from "./layouts/Main.vue";
import BaseFileUploader from "../components/BaseFileUploader";
//import BaseFileUploader from "../components/BaseFileUploader";
import BaseButton from "../components/BaseButton";
import BaseInput from "../components/BaseInput";
//import emailjs from 'emailjs-com';
import { mapGetters } from "vuex";
//import { create } from "core-js/core/object";

export default {
  name: "adminmemberview",
  components: { Layout, BaseButton, BaseInput, BaseFileUploader},
  data() {
    return {
      admin: {},
      member: {},
      //member : "",
      businessPartner: "",
      //fileUrl: "",
      array : "",
      sermonLink: "",
      timer100: "",
      marriageStatus :  "",
      mobileOpen10 : false,
      firstName : "",
      lastName : "",
      //memberNo : "",
      address: "",
      birthDate : "",
      emailAddress : "",
      fullName : "",
      mobileNo : "",
      mobileOpen30 : "",
      otherTel : "",
      memberNo : "",
      baptismDate : "",
      membershipDate : "",
      additionalInformation : "",
      baptizedGrace : "",
      errors: [],
     

    };
  },
  created() {
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
    if (this.type !== "admin" ) {
      this.$router.push({
        name: "Home",
      });
    }
    this.getMemberData();
    
    //this.getSermonID();
    //this.getEmployeeCertificate();
    
  },
  mounted(){

    //this.getLicenseData();

  },
  computed: {
    ...mapGetters(["currentUserData"]),
  },
  methods: {
    getMemberData() {
      const employeeRef = this.$db
        .collection("members")
        .doc(this.$route.params.id);

      employeeRef.get().then((doc) => {
        this.admin = doc.data();
      });
      //this.timer100 = setTimeout(this.getSermonID, 1000)
    },
    getFullName(){
      this.fullName = this.admin.firstName + ' ' + this.admin.lastName
      
    },
      createArray(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.fullName.length; i++){
      this.array.push(this.fullName.slice(0,i+1).toLowerCase());
      }
    },
      removeUser() {

      const confirm = window.confirm(
        "Are you sure you would like to Remove this user?"
      );
      if (confirm) {
      this.$db.collection("members").doc(this.$route.params.id).delete().then(function() {
            
        console.log("Member successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
       this.getMemberData();
      }
    },
    addMember() {
     
 
      if(this.marriageStatus == 'Married')  
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          address : this.address,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          marriageStatus : this.marriageStatus,
          marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          baptizedGrace : this.baptizedGrace,
          baptismDate : this.baptismDate,
          membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
          activeMember : true,
        });

        window.confirm(
          "Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
      else
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          address : this.address,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          marriageStatus : this.marriageStatus,
          //marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          baptizedGrace : this.baptizedGrace,
          baptismDate : this.baptismDate,
          membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
           activeMember : true,
        });

        window.confirm(
          "Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
      
      
    },
      toggleMobilemenu30() {
      this.mobileOpen30 = !this.mobileOpen30;
    },
         toggleMobilemenu10() {
      this.mobileOpen10 = !this.mobileOpen10;
    },
    becomeMember(){
       this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          membershipDate: this.admin.membershipDate,
          activeMember: "YES",
           isMember : "YES",
          NonSearch : "",
          updatedDate : Date.now(),
        })
         this.getMemberData();
         window.confirm(
          "You have become a member."
        );
        this.getMemberData();
        this.toggleMobilemenu10();
        //this.updateMemberID();
        //this.redirect();
      
      
    },


    updateMember() {
      if(this.admin.baptizedGrace === 'NO')
    {
      if(this.admin.marriageStatus == 'Married')  
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.admin.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
          address : this.admin.address,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          marriageStatus : this.admin.marriageStatus,
          marriageDate : this.admin.marriageDate,
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          baptizedGrace : "",
          baptismDateElse : "",
          baptismDate : "",
          activeMember: this.admin.activeMember,
          membershipDate : "",
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
          //activeMember : true,
        });

        window.confirm(
          "Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
      else
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
          address : this.admin.address,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
          baptismDateElse : "",
          marriageStatus : this.admin.marriageStatus,
          marriageDate : "",
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          baptizedGrace : this.admin.baptizedGrace,
          activeMember: this.admin.activeMember,
          baptismDate : "",
          membershipDate : "",
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
           //activeMember : true,
        });

        window.confirm(
          "Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
    }
    else
    {
      if(this.admin.marriageStatus == 'Married')  
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.admin.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
          address : this.admin.address,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          marriageStatus : this.admin.marriageStatus,
          marriageDate : this.admin.marriageDate,
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          baptizedGrace : this.admin.baptizedGrace,
          baptismDateElse : "",
          baptismDate : this.admin.baptismDate,
          activeMember: this.admin.activeMember,
          membershipDate : this.admin.membershipDate,
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
          //activeMember : true,
        });

        window.confirm(
          "Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
      else
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
          address : this.admin.address,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
           baptismDateElse : "",
          marriageStatus : this.admin.marriageStatus,
          marriageDate : "",
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          baptizedGrace : this.admin.baptizedGrace,
          activeMember: this.admin.activeMember,
          baptismDate : this.admin.baptismDate,
          membershipDate : this.admin.membershipDate,
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
           //activeMember : true,
        });

        window.confirm(
          "Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
    }


    },
     updateMemberNon() {
    if(this.admin.marriageStatus == 'Married')  
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.admin.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
           NonSearch : this.fullName,
          address : this.admin.address,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          marriageStatus : this.admin.marriageStatus,
          marriageDate : this.admin.marriageDate,
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          //baptizedGrace : this.admin.baptizedGrace,
          baptismDateElse : "",
         // baptismDate : this.admin.baptismDate,
          activeMember: this.admin.activeMember,
          //membershipDate : this.admin.membershipDate,
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
          //activeMember : true,
        });

        window.confirm(
          "Non Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
      else
      {
         this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          //memberNo : this.memberNo,
          firstName : this.admin.firstName,
          lastName : this.admin.lastName,
          fullName : this.fullName,
           NonSearch : this.fullName,
          address : this.admin.address,
          emailAddress : this.admin.emailAddress,
          birthDate : this.admin.birthDate,
          spouse: this.admin.spouse,
          children: this.admin.children,
          childrenNames: this.admin.childrenNames,
           baptismDateElse : "",
          marriageStatus : this.admin.marriageStatus,
          marriageDate : "",
          mobileNo : this.admin.mobileNo,
          otherTel : this.admin.otherTel,
          //baptizedGrace : this.admin.baptizedGrace,
          activeMember: this.admin.activeMember,
          //baptismDate : this.admin.baptismDate,
         // membershipDate : this.admin.membershipDate,
          additionalInformation : this.admin.additionalInformation,
          updatedBy: this.currentUserData.email,
          updatedDate : Date.now(),
          search: this.array,
           //activeMember : true,
        });

        window.confirm(
          "Non Member was updated successfully."
        );
        //this.updateMemberID();
        this.redirect();
      }
    },
    addNumber() {
       this.memberNo = this.member.memberID+=1;
     },
      updateMemberID(){
      this.$db
        .collection("memberID")
        .doc(this.member.id)
        .update({
          memberID: this.memberNo,
        })
        //.then(() => this.getPendingApprovals());
        //this.$router.push({
        //name: "dashboard",})
    },
    removePic(){
      this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          profilePic: "",
        })
        window.confirm(
          "Picture was removed successfully."
        );
       this.getMemberData();
    },
    
    clear(){
      this.marriageStatus =  "",
      this.firstName =  "",
      this.lastName =  "",
      this.address =  "",
      this.birthDate =  "",
      this.emailAddress =  "",
      this.mobileNo =  "",
      this.otherTel =  "",
      this.baptismDate =  "",
      this.membershipDate =  "",
      this.additionalInformation =  "",
      this.baptizedGrace = "",
      this.fullName = "",
      this.errors = ""

    },
    handleAdminDocument1({ fileUrl }) {
      this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
          profilePic: fileUrl,
        })
       //this.getMemberData();
       //this.toggleMobilemenu30();
    },
        handleAdminDocument({ fileUrl }) {
      this.$db
        .collection("members")
        .doc(this.$route.params.id)
        .update({
           profilePic1: fileUrl,
        })
        //.then(() => this.getEmployerData());
        
    },
    getSermonID() {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", this.admin.sermonID)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
  

    checkForm: function (e) {
      this.errors = [];

       
        if (!this.admin.firstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.admin.lastName) {
          this.errors.push("Last Name is required...");
        }
        if (!this.admin.address) {
          this.errors.push("Address is required...");
        }
        if (!this.admin.birthDate) {
          this.errors.push("birth Date is required...");
        }
        if (!this.admin.marriageStatus) {
          this.errors.push("Marriage Status is required...");
        }
        if (!this.admin.emailAddress) {
          this.errors.push("Email Address is required...");
        }
        if (!this.admin.mobileNo) {
          this.errors.push("Mobile is required...");
        }
        if (!this.admin.otherTel) {
          this.errors.push("Other Tel is required...");
        }
        if (!this.admin.baptizedGrace) {
          this.errors.push("Baptized at Grace is required...");
        }
       
      
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
          checkForm1: function (e) {
      this.errors = [];

       
        if (!this.admin.firstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.admin.lastName) {
          this.errors.push("Last Name is required...");
        }
        if (!this.admin.address) {
          this.errors.push("Address is required...");
        }
        if (!this.admin.birthDate) {
          this.errors.push("birth Date is required...");
        }
        if (!this.admin.marriageStatus) {
          this.errors.push("Marriage Status is required...");
        }
        if (!this.admin.emailAddress) {
          this.errors.push("Email Address is required...");
        }
        if (!this.admin.mobileNo) {
          this.errors.push("Mobile is required...");
        }
        if (!this.admin.otherTel) {
          this.errors.push("Other Tel is required...");
        }
    
       
      
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
    updateSermonLink() {
      this.$db
        .collection("sermonLinks")
        .doc(this.sermonLink.id)
        .update({
          //clientName: this.company.clientName.toLowerCase(),
         document: this.sermonLink.document,
        
        });
      //this.pages.homeJobSeeker = this.homeJobSeeker,
      window.confirm("Sermon Link Has been updated.");
       this.timer100 = setTimeout(this.getSermonID, 1000)
    },


    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },

  }
};
</script>
